/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_YesInputs */

const en_ticket_review_yes = /** @type {(inputs: Ticket_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const ja_ticket_review_yes = /** @type {(inputs: Ticket_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const fr_ticket_review_yes = /** @type {(inputs: Ticket_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_ticket_review_yes = /** @type {(inputs: Ticket_Review_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Ticket_Review_YesInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_yes = /** @type {((inputs?: Ticket_Review_YesInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_YesInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_yes(inputs)
	if (locale === "ja") return ja_ticket_review_yes(inputs)
	if (locale === "fr") return fr_ticket_review_yes(inputs)
	return de_ticket_review_yes(inputs)
});